import * as t from "io-ts";
import { RecipeCodec } from "./CategoriesResponseCodec";

export const RestoreCodec = t.strict({
    recipe: RecipeCodec,
    message: t.string,
    restored: t.boolean
});

export type RestoreResponse = t.OutputOf<typeof RestoreCodec>;